export type DefaultAppConfig = {
    tunnelerEnabledReadOnly: boolean;
    isOpenZiti?: boolean;
};

export const DEFAULT_APP_CONFIG_PROP = {
    tunnelerEnabledReadOnly: true,
    isOpenZiti: true
};